import {
    TFormalOffer,
    TFormalOffers
} from '@helpers/FormalOffers/formalOffers.types';
import { getFormalOffersMaxAvailableCash } from '@helpers/FormalOffers/getFormalOffersMaxAvailableCash';
import { getTimeOutDate } from '@helpers/FormalOffers/getTimeOutDate';
import { tracking } from '@iwoca/frontend-tracking-library';

import { ChooseAmount } from './ChooseAmount/ChooseAmount';
import { ChooseDuration } from './ChooseDuration/ChooseDuration';
import { ApprovalHeader } from '../../../components/ApprovalHeader/ApprovalHeader';
import { BenefitsList } from '../../../components/BenefitsList/BenefitsList';
import { CompareOffers } from '../../../components/CompareOffers/CompareOffers';

export const OfferConfiguration = ({
    formalOffers,
    drawdownAmount,
    onDrawdownAmountChange,
    selectedOffer,
    onSelectOffer
}: {
    formalOffers: TFormalOffers;
    drawdownAmount: number;
    onDrawdownAmountChange: (amount: number) => void;
    selectedOffer: TFormalOffer | undefined;
    onSelectOffer: (offerId: string) => void;
}) => {
    const maxCashAmount = getFormalOffersMaxAvailableCash(formalOffers);
    const timeoutDate = getTimeOutDate(formalOffers);

    return (
        <div className="space-y-xl" data-testid="offer-configuration">
            <div>
                <ApprovalHeader
                    approvalStatusTimeOut={timeoutDate}
                    maxCashAmount={maxCashAmount}
                />
                <BenefitsList />
            </div>
            <ChooseAmount
                selectedAmount={drawdownAmount}
                onChange={onDrawdownAmountChange}
                maxAmount={maxCashAmount}
            />
            <div className="space-y-s px-l min-sm:px-xl">
                <ChooseDuration
                    formalOffers={formalOffers}
                    selectedOfferId={selectedOffer?.offer_id}
                    drawdownAmount={drawdownAmount}
                    onSelect={onSelectOffer}
                />
                <CompareOffers
                    formalOffers={formalOffers}
                    drawdownAmount={drawdownAmount}
                    selectedOffer={selectedOffer}
                    onOpen={() => tracking.ampli.compareOffersTableOpened()}
                />
            </div>
        </div>
    );
};
